import { render, staticRenderFns } from "./ShiftsReport.vue?vue&type=template&id=714c637f&"
import script from "./ShiftsReport.vue?vue&type=script&lang=ts&"
export * from "./ShiftsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports